import { useRemoteResource } from "./useRemoteResource";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #642/#638 — the ring's scheduled breaks. These are NOT rides: reconcile drops
// FVD's ***Break*** / ***Lunch*** placeholders before they can become score-ride
// rows (#585, by design — a break must never be scored, placed or emailed) and
// projects them into their own score-break table instead. So the Order of Go
// merges two lists client-side; a break will never appear in GET /ride.
//
// GET /break already returns rows sorted by scheduledTime (missing last), but we
// re-sort anyway when merging with rides.
//
// #2190 — no local cache: a network failure leaves whatever breaks are
// already on screen exactly as they are (see useRemoteResource).
// #2217 — `[showId, ring]` as `resourceKey` (docs in useRemoteResource.js
// and useRingStateForRing.js): same AC3 consistency as useRidesForRing.
// #2227: same call as useRidesForRing.js (its comment has the full
// reasoning): `initialValue` stays at the default `null`, because a failed
// first fetch after a reset settling to "no rides/breaks" (oog-empty) was
// already this hook's accepted cold-start-failure answer since #2190, not
// a new false claim #2217 introduced.
export function useBreaksForRing(showId, ring, nonce = 0) {
  const api = useScoreApi();
  return useRemoteResource(
    async () => {
      if (!showId || !ring) return [];
      return unwrap(await api.breaks.listBreaks(showId, ring)) ?? [];
    },
    [api, showId, ring, nonce],
    [showId, ring],
  );
}

export default useBreaksForRing;
